import _ from "lodash";
import React, { Component, Fragment } from "react";

import styled from "styled-components";

import DialogChooseItem from "./DialogChooseItem";
import CustomInput from "../../../common/CustomInput";
import ActionButton from "../../../common/ActionButton";

const InputWithButtonWrapper = styled.div`
  width: 48%;
  display: flex;
`;

const InputButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-left: 8px;
  padding-bottom: ${({ hasError }: any) => (hasError ? 29 : 8)}px;
`;

const InputWrapper = styled.div`
  width: 100%;
`;

type Props = {
  setFieldValue: Function;
  onCreateItem: Function;
  dataset: Array<any>;
  fieldData;
  errors;
  values: any;
  item;
  mode: string;
  id: string;
  canCreateNewItem?: boolean;
  showDataset?: boolean;
};

type State = {
  isDialogChooseItemOpen: boolean;
  dialogConfig;
};

class InputWithCreation extends Component<Props, State> {
  state = {
    isDialogChooseItemOpen: false,
    dialogConfig: {},
  };

  componentDidMount() {
    const { setFieldValue, item, id, showDataset, dataset } = this.props;

    if (!showDataset) setFieldValue([id], item[id]);
  }

  onToggleDialogChooseItem = (): void => {
    const { isDialogChooseItemOpen } = this.state;

    this.setState({
      isDialogChooseItemOpen: !isDialogChooseItemOpen,
    });
  };

  onSetItemIntoForm = (item: any): void => {
    const { setFieldValue, id, values, showDataset, dataset } = this.props;
    let newItem = item;

    if (!!showDataset) {
      //Can add item into form, it doesnt exist
      if (values[id].findIndex((val) => val.id === item.id) !== -1) {
        this.onToggleDialogChooseItem();
        return;
      } else newItem = [item, ...values[id]];
    }
    setFieldValue([id], newItem);

    const selectedCategory = dataset.find((category) => category.name === item);

    if (selectedCategory) {
      setFieldValue(["categoryId"], selectedCategory.id);
    }

    this.onToggleDialogChooseItem();
  };

  renderChoiceInputItem = (field: any) => {
    const { errors, values, mode, showDataset } = this.props;

    const isTitleEdit = mode === "edit" || values[field.id];
    const buttonTitle = isTitleEdit ? "EDIT" : "ADD";

    const inputValue =
      !!showDataset && _.get(values, field.id).length > 0
        ? _.get(values, field.id)[0]?.name
        : _.get(values, field.id);

    return (
      <InputWithButtonWrapper>
        <InputWrapper>
          <CustomInput
            value={inputValue}
            placeholder={field.placeholder}
            error={errors[field.id]}
            label={field.label}
            id={field.id}
            type="text"
            disabled
          />
        </InputWrapper>
        <InputButtonWrapper
          //@ts-ignore
          hasError={errors[field.id]}
        >
          <ActionButton
            action={() => this.onToggleDialogChooseItem()}
            disabled={mode === "detail"}
            title={buttonTitle}
            withIcon={false}
          />
        </InputButtonWrapper>
      </InputWithButtonWrapper>
    );
  };

  renderDialog = () => {
    const { isDialogChooseItemOpen } = this.state;

    const {
      onCreateItem,
      dataset,
      values,
      mode,
      id,
      canCreateNewItem,
      showDataset,
    } = this.props;

    const itemSelected = values[id];

    const Dialog = (
      <DialogChooseItem
        canCreateNewItem={canCreateNewItem}
        onToggleDialog={this.onToggleDialogChooseItem}
        onSetItem={this.onSetItemIntoForm}
        isOpen={isDialogChooseItemOpen}
        onCreateItem={onCreateItem}
        itemSelected={itemSelected}
        dataset={dataset}
        entity={id}
        mode={mode}
        showDataset={showDataset}
      />
    );

    return dataset ? Dialog : null;
  };

  render() {
    const { fieldData } = this.props;

    return (
      <Fragment>
        {this.renderChoiceInputItem(fieldData)}
        {this.renderDialog()}
      </Fragment>
    );
  }
}

export default InputWithCreation;
